<template>

    <div class="container">
        <widget-content
            v-if="brand.data.content !== null"
            :html-content="brand.data.content"
        />
        <h1 v-else v-text="brand.data.name"></h1>

        <div class="mt-5">
            <inertia-link
                :href="route('products.brand-products', {brand_slug:this.brand.data.slug})"
                class="btn btn-primary"
                v-text="lang('brands.view-brand-products')"
            ></inertia-link>
        </div>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import WidgetContent from "../../../components/Widgets/WidgetContent.vue";

export default {

    components: {
        WidgetContent,
    },

    destroyed() {
        this.$pageHeader.show();
    },

    layout: Layout,

    metaInfo() {
        return {
            title: this.brand.data.pagetitle,
            meta: [
                {vmid:'keywords',name:'keywords',content:this.brand.data.meta_keywords},
                {vmid:'description',name:'description',content:this.brand.data.meta_description},
            ],
        }
    },

    mounted() {
        this.$pageHeader.hide();
    },

    name: 'OpenBrandsItem',

    props: {
        brand: {
            required:true,
            type: Object,
        },
    },

}

</script>
